const groupsRepository = (fetch: CustomFetch) => ({
  async getGroups(parameters?: Record<string, string>) {
    const params = new URLSearchParams(parameters)
    return await fetch<Group[]>(`/v3/groups${params.size ? `?${params.toString()}` : ''}`)
  },

  async getGroup(id: string): Promise<GroupDetail> {
    return await fetch<GroupDetail>(`/v3/groups/${id}?includeMembers=true`)
  },

  async createGroup(group: GroupCreatePayload): Promise<Group> {
    return await fetch<Group>(`/v3/groups`, {
      method: 'POST',
      body: group,
    })
  },

  async updateGroup(group: GroupCreatePayload): Promise<Group> {
    return await fetch<Group>(`/v3/groups/${group.id}`, {
      method: 'PUT',
      body: group,
    })
  },

  async deleteGroup(id: string) {
    await fetch(`/v3/groups/${id}`, { method: 'DELETE' })
  },
})

export default groupsRepository
